import SecuredCardLandingPage from "./SecuredCardLandingPage";
export default SecuredCardLandingPage;
